'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cjs/react-is.production.min.js');
} else {
  module.exports = require('./cjs/react-is.development.js');
}



//////////////////
// WEBPACK FOOTER
// /Users/cully/projects/Jobs/abound/~/react-is/index.js
// module id = ../../node_modules/react-is/index.js
// module chunks = 18